module.exports = __webpack_public_path__ + "img/htpz.9929532c.jpg";